var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26059 7.88402L0.140583 4.59425C-0.046861 4.3966 -0.046861 4.07615 0.140583 3.87848L0.81939 3.16272C1.00683 2.96505 1.31077 2.96505 1.49822 3.16272L3.6 5.37885L8.10178 0.632119C8.28923 0.434476 8.59317 0.434476 8.78061 0.632119L9.45942 1.34788C9.64686 1.54553 9.64686 1.86598 9.45942 2.06365L3.93941 7.88404C3.75195 8.08169 3.44803 8.08169 3.26059 7.88402Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0022781bb7cf03b6975da7a3dfb675a3.svg";
export { ForwardRef as ReactComponent };